export const theme = {
    colors: {
        skyBlue: "#009EFF",
        lightGray: "#8d99ae",
        darkGray: "#5a667a",
        white: "#ffffff",
        black: "#000000",
        lightBlue: "#e0f0fe",
    }
}